<template>
 <svg :style="style"  width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#229;&#164;&#167;&#229;&#176;&#143;&#231;&#177;&#187;&#229;&#158;&#139;=&#229;&#164;&#167;40, &#231;&#167;&#145;&#229;&#174;&#164;&#229;&#144;&#141;&#231;&#167;&#176;=&#229;&#145;&#188;&#229;&#144;&#184;&#229;&#134;&#133;&#231;&#167;&#145;">
<path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M20.8617 16.7034V7.13979C20.8617 6.65489 20.4696 6.25854 19.9805 6.25854C19.4956 6.25854 19.0992 6.65068 19.0992 7.13979V16.7515C18.5886 16.8561 18.0905 17.0402 17.6235 17.3033V16.066C17.6235 14.8896 16.6621 13.9283 15.4857 13.9283H14.5707C8.27557 13.9283 3.12305 19.0808 3.12305 25.376V31.3212C3.12305 32.6536 4.21089 33.7415 5.5433 33.7415H10.6326C14.478 33.7415 17.6235 30.596 17.6235 26.7506V20.1013L18.1656 19.6108C18.5512 19.263 19.0033 19.0347 19.4765 18.927C19.619 19.0266 19.7926 19.085 19.9805 19.085C20.1935 19.085 20.3881 19.0106 20.54 18.8863C21.0425 18.9606 21.5316 19.1683 21.9552 19.5108L22.371 19.8487V26.7213C22.371 30.5667 25.5165 33.7122 29.3619 33.7122H34.4511C35.7835 33.7122 36.8714 32.6243 36.8756 31.2962V25.3509C36.8756 19.0515 31.7231 13.899 25.4237 13.899H24.5087C23.3323 13.899 22.371 14.8604 22.371 16.0368V17.1768C21.8889 16.9379 21.3796 16.7803 20.8617 16.7034Z" fill="white"/>
</g>
</svg>


</template>

<script>
export default {
  name: 'icon-hxnk',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>